import useNavigator from "@saleor/hooks/useNavigator";
import useUser from "@saleor/hooks/useUser";
import { orderListUrl } from "@saleor/motherOrders/urls";
import useBrandPrivateSearch from "@saleor/searches/useBrandPrivateSearch";
import useStoreSearch from "@saleor/searches/useStoreSearch";
import { storeOrderListUrl } from "@saleor/storeOrders/urls";
// import { searchTenants } from "@saleor/searches/useTenantSearch";
import {
  OrderDirection,
  SmopOrderStatusEnum,
  SmopUserTypeCode,
  TenantSortField
} from "@saleor/types/globalTypes";
import { SmopStatusEnum } from "@saleor/types/globalTypes";
import { getGteLteVariables } from "@saleor/utils/filters";
import Moment from "moment";
import React, { useEffect, useState } from "react";

import { getUserName, maybe } from "../../misc";
// import { orderListUrl } from "../../motherOrders/urls";
import { productVariantEditUrl } from "../../products/urls";
// import { OrderStatusFilter } from "../../types/globalTypes";
import HomePage, { SellerBrandFormData } from "../components/HomePage";
import {
  useCountMotherOrders,
  useCountStoreOrders,
  useSalesTodayQuery,
  useTopProducts
} from "../queries";
import { kamsUrl, KamsUrlQueryParams } from "../url";
const DEFAULT_INITIAL_SEARCH_STORE_DATA = {
  after: null,
  direction: OrderDirection.ASC,
  field: TenantSortField.NUMBER,
  first: 20,
  query: "",
  status: SmopStatusEnum.ACT
};

interface HomepageProps {
  params: KamsUrlQueryParams;
}

const HomeSection: React.FC<HomepageProps> = ({ params }) => {
  // console.log(params.brand);
  const brandID = params.brand ? params.brand : null;
  const navigate = useNavigator();
  const { user } = useUser();
  const [currentStoreId, setCurrentStoreId] = useState(null);
  const [currentBrandId, setCurrentBrandId] = useState(brandID);
  useEffect(() => {
    setCurrentBrandId(brandID);
  }, [brandID]);

  const { search: searchStore, result: tenants } = useStoreSearch({
    skip:
      user.userType.code !== SmopUserTypeCode.SELLER_MASTER &&
      user.userType.code !== SmopUserTypeCode.ACCOUNT_MANAGER,
    variables: {
      ...DEFAULT_INITIAL_SEARCH_STORE_DATA,
      brand: brandID ? [currentBrandId] : []
    }
  });
  // console.log('currentStoreId');
  // console.log(currentStoreId);
  const { data: totalSales } = useSalesTodayQuery({
    displayLoader: true,
    skip:
      user.userType.code === SmopUserTypeCode.SELLER_MASTER ||
      user.userType.code === SmopUserTypeCode.ACCOUNT_MANAGER
        ? currentStoreId === null
        : false,
    variables: {
      tenantId: currentStoreId
    }
  });

  const dateToday = new Date().toLocaleString() + "";

  const createTenantParams = () => {
    if (
      user.userType.code === SmopUserTypeCode.SELLER_MASTER ||
      user.userType.code === SmopUserTypeCode.ACCOUNT_MANAGER
    ) {
      return { tenant: [currentStoreId] };
    }
    return {};
  };

  const { data: totalOrdersToday } = useCountStoreOrders({
    displayLoader: true,
    skip:
      user.userType.code === SmopUserTypeCode.SELLER_MASTER ||
      user.userType.code === SmopUserTypeCode.ACCOUNT_MANAGER
        ? currentStoreId === null
        : false,
    variables: {
      filter: {
        ...createTenantParams(),
        created: getGteLteVariables({
          gte: Moment(dateToday).format("YYYY-MM-DD"),
          lte: Moment(dateToday).format("YYYY-MM-DD")
        })
      }
    }
  });

  const { data: totalNewOrders } = useCountStoreOrders({
    displayLoader: true,
    skip:
      user.userType.code === SmopUserTypeCode.OMI_ADMIN ||
      (user.userType.code === SmopUserTypeCode.SELLER_MASTER ||
      user.userType.code === SmopUserTypeCode.ACCOUNT_MANAGER
        ? currentStoreId === null
        : false),
    variables: {
      filter: {
        ...createTenantParams(),
        smopStatus: [SmopOrderStatusEnum.NEW_ORDER]
      }
    }
  });

  const { data: totalReadyOrders } = useCountMotherOrders({
    displayLoader: true,
    skip:
      user.userType.code === SmopUserTypeCode.STORE_ADMIN ||
      user.userType.code === SmopUserTypeCode.SELLER_MASTER,
    variables: {
      filter: {
        smopStatus: [SmopOrderStatusEnum.READY]
      }
    }
  });

  const { data: topProducts } = useTopProducts({
    displayLoader: true,
    skip:
      user.userType.code === SmopUserTypeCode.SELLER_MASTER ||
      user.userType.code === SmopUserTypeCode.ACCOUNT_MANAGER
        ? currentStoreId === null
        : false,
    variables: {
      tenantId: currentStoreId
    }
  });

  // AUTOCOMPLETE SEARCH
  const brandInitialSearchData = {
    after: null,
    first: 20,
    query: ""
  };
  const {
    loadMore: loadMoreBrand,
    search: searchBrands,
    result: brandsQueryData
  } = useBrandPrivateSearch({
    variables: {
      ...brandInitialSearchData,
      accountManager: user.id
    }
  });
  const sellerBrandChoices = maybe(
    () => brandsQueryData?.data?.search?.edges,
    []
  ).map(edge => edge.node);

  const [brandLabel, setBrandLabel] = useState("");
  const [hasBrandID, setHasBrandID] = useState(true);
  const getBrand = (brandID, choices) => {
    const getBrand = choices.find(brand => brand.id === brandID);
    if (getBrand && hasBrandID) {
      setBrandLabel(getBrand.name + " - " + getBrand.legalName);
      setHasBrandID(false);
    }
  };

  // if (params.brand) {
  //   getBrand(params.brand, sellerBrandChoices);
  // }

  useEffect(() => {
    if (sellerBrandChoices && params.brand) {
      getBrand(params.brand, sellerBrandChoices);
    }
  }, [sellerBrandChoices]);

  const handleSubmit = async (data: SellerBrandFormData) => {
    navigate(kamsUrl({ brand: data.sellerBrand }));
  };
  // data;
  return (
    // <HomePageQuery displayLoader variables={getTenantId()}>
    //   {({ data }) => (
    <HomePage
      brands={sellerBrandChoices}
      brandLabel={brandLabel}
      brandID={currentBrandId}
      fetchBrands={query => searchBrands(query)}
      fetchMoreBrands={{
        hasMore: maybe(() => brandsQueryData.data.search.pageInfo.hasNextPage),
        loading: brandsQueryData.loading,
        onFetchMore: loadMoreBrand
      }}
      fetchTenants={searchStore}
      // activities={maybe(() =>
      //   data.activities.edges.map(edge => edge.node).reverse()
      // )}
      motherOrders={maybe(() => totalReadyOrders.orders.totalCount)}
      orders={maybe(() => totalOrdersToday.storeOrders.totalCount)}
      sales={maybe(() => totalSales.storeOrdersTotal.gross)}
      showTenants={
        user.userType.code === SmopUserTypeCode.SELLER_MASTER ||
        user.userType.code === SmopUserTypeCode.ACCOUNT_MANAGER
      }
      storeOrders={maybe(() => totalNewOrders.storeOrders.totalCount)}
      tenants={maybe(
        () => tenants.data.search.edges.map(edge => edge.node),
        []
      )}
      topProducts={maybe(
        () =>
          (user.userType.code !== SmopUserTypeCode.OMI_OPS ||
            user.userType.code !== SmopUserTypeCode.OMI_ADMIN) &&
          topProducts.reportProductSales.edges.map(edge => edge.node)
      )}
      onProductClick={(productId, variantId) =>
        navigate(productVariantEditUrl(productId, variantId))
      }
      onMotherOrdersClick={() =>
        user.userType.code !== SmopUserTypeCode.OMI_ADMIN &&
        navigate(
          orderListUrl({ activeTab: "2", status: SmopOrderStatusEnum.READY })
        )
      }
      onStoreOrdersClick={() =>
        user.userType.code !== SmopUserTypeCode.SELLER_MASTER &&
        navigate(
          storeOrderListUrl({
            activeTab: "0",
            status: SmopOrderStatusEnum.NEW_ORDER
          })
        )
      }
      onSubmit={handleSubmit}
      // onOrdersToCaptureClick={() =>
      //   navigate(
      //     orderListUrl({
      //       // status: [OrderStatusFilter.READY_TO_CAPTURE]
      //     })
      //   )
      // }
      // onOrdersToFulfillClick={() =>
      //   navigate(
      //     orderListUrl({
      //       // status: [OrderStatusFilter.READY_TO_FULFILL]
      //     })
      //   )
      // }
      // onProductsOutOfStockClick={() =>
      //   navigate(
      //     productListUrl({
      //       // stockStatus: StockAvailability.OUT_OF_STOCK
      //     })
      //   )
      // }
      // ordersToCapture={maybe(() => data.ordersToCapture.totalCount)}
      // ordersToFulfill={maybe(() => data.ordersToFulfill.totalCount)}
      // productsOutOfStock={maybe(() => data.productsOutOfStock.totalCount)}
      onChangeStore={id => {
        setCurrentStoreId(id);
      }}
      userName={getUserName(user, true)}
      userPermissions={user?.userPermissions || []}
    />
    //   )}
    // </HomePageQuery>
  );
};

export default HomeSection;
